import type { Role } from "@/api/models";
export type { Role } from "@/api/models";

export function isAdminRole(role: Role | undefined): boolean {
  return role === "chief" || role === "respai_admin";
}

/** Human label for a role. A user can hold several (e.g. chief + IC). */
export function roleLabel(role: Role): string {
  switch (role) {
    case "respai_admin":
      return "Admin";
    case "chief":
      return "Chief";
    case "incident_commander":
      return "Incident commander";
    case "firefighter":
      return "Firefighter";
  }
}

export function isRespaiAdmin(role: Role | undefined): boolean {
  return role === "respai_admin";
}

export function canEditReport(role: Role | undefined): boolean {
  return isAdminRole(role);
}

export function canManageUsers(role: Role | undefined): boolean {
  return isAdminRole(role);
}
